import axios from 'axios';

import { apiConfig, DSP_ACCESS_TOKEN_KEY, DSP_CLIENT_TOKEN_KEY } from '@constants';

import { getStorageItem, setStorageItem } from './storage';

export const getDspAuthHeader = async (forceRefresh = false) => {
  const { accessToken } = await getDspAccessToken(forceRefresh);
  const { clientToken } = await getDspClientToken(forceRefresh);

  if (!accessToken || !clientToken) {
    return null;
  }

  return {
    ['x-access-token']: accessToken,
    ['x-client-token']: clientToken,
  };
};

export const getDspAccessToken = async (forceRefresh = false) => {
  const accessToken = getStorageItem(DSP_ACCESS_TOKEN_KEY);

  if (forceRefresh || !accessToken) {
    return await refreshDspAccessToken();
  }

  return {
    accessToken,
    error: null,
  };
};

export const refreshDspAccessToken = async () => {
  const bodyFormData = new FormData();

  bodyFormData.append('key', apiConfig.DSP_API_KEY);
  const { data, status } = await axios.post(`${apiConfig.DSP_TOKEN_URL}?token=${apiConfig.DSP_API_KEY}`, bodyFormData);

  const values =
    status === 200 && data.token
      ? {
          accessToken: data.token,
          error: null,
        }
      : {
          accessToken: '',
          error: 'invalid API key',
        };

  /**
   * Update storage regardless of success or failure. if failed in refreshing,
   * then erase the old token from storage so the app shouldn't use it anymore
   */
  setStorageItem(DSP_ACCESS_TOKEN_KEY, values.accessToken);

  return values;
};

export const getDspClientToken = async (forceRefresh = false) => {
  const clientToken = getStorageItem(DSP_CLIENT_TOKEN_KEY);

  if (forceRefresh) {
    return await refreshDspClientToken();
  }

  if (!clientToken) {
    return { clientToken: null };
  }

  return { clientToken };
};

export const refreshDspClientToken = async () => {
  const headers = await getDspAuthHeader();

  if (!headers) {
    return {
      clientToken: undefined,
      error: 'Token refresh error',
    };
  }

  const { data } = await axios.post(apiConfig.DSP_TOKEN_REFRESH_URL, null, {
    headers,
  });

  // if failed in refreshing, erase the old token from storage so the app shouldn't use it anymore
  if (!data?.success) {
    setStorageItem(DSP_CLIENT_TOKEN_KEY, '');

    return {
      clientToken: headers?.['x-client-token'],
      error: 'Token refresh error',
    };
  }

  setStorageItem(DSP_CLIENT_TOKEN_KEY, data.client_token);

  return { clientToken: data.client_token };
};
